<template>
  <div class="tree-default">
    <vue-okr-tree @node-click="treeClick" ref="tree" :label-height="30" :render-content="renderContent" node-key="id" :data="tree">
    </vue-okr-tree>

    <!-- 团队提示框 -->
    <el-dialog v-dialogDrag title="团队人员信息" :close-on-click-modal="false" :visible.sync="treedialog" class="treedialog">
      <div class="dialogcontent">
        <div class="left">
          <li @click="clickitem(item)" v-for="(item,i) in tableData" :key='i' :class="item.id==index?'active':''">{{item.stationUser}}</li>

        </div>
        <div class="right">
          <div class="img">
            <!-- <img src="@/assets/images/defaultAvt.jpg"/> -->
            <img :src="formData.stationImg" />
          </div>
          <div class="form">
            <div class="item"><label>姓名：</label><span>{{formData.stationUser}}</span></div>
            <!-- <div class="item"><label>联系电话：</label><span>13821585858</span></div> -->
            <div class="item"><label>岗位：</label><span>{{formData.stationName}}</span></div>
            <div class="item"><label>描述：</label><span>{{formData.stationDuty}}</span></div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { VueOkrTree } from 'vue-okr-tree'
import 'vue-okr-tree/dist/vue-okr-tree.css'

export default {
  props: ['tree'],
  components: {
    VueOkrTree,
  },
  data() {
    return {
      treedialog: false,
      tableData: [],
      formData: {},
      index: 0,
    }
  },
  watch: {
    tree() {
      let tree = JSON.parse(JSON.stringify(this.tree))

      this.tableData = this.treeToList(tree)


    },
  },
  mounted() {},
  methods: {
    treeToList(tree) {
      var queen = []
      var out = []
      queen = queen.concat(tree)
      while (queen.length) {
        var first = queen.shift()
        if (first.children) {
          queen = queen.concat(first.children)
          delete first['children']
        }
        out.push(first)
      }
      return out
    },

    //自定义树节点
    renderContent(h, node) {
      return (
        <div class="name">
          <img class="diy-con-img" src={node.data.stationImg} />
          <p>{node.data.stationName}</p>
        </div>
      )
    },
    treeClick(node) {
      this.formData = node
      this.index = node.id
      this.treedialog = true
    },
    clickitem(row) {
      this.formData = row
      this.index = row.id
    },
  },
}
</script>
<style lang='less'>
.tree-default {
  margin-top: 20px;
  .name {
    font-size: 0.68rem;
    color: #ccd0f2;
    border: #ccd0f2 solid 1px;
    border-radius: 4px;
    padding: 4px 12px 6px;
    img {
      width: 2rem;
      height: 2.5rem;
    }
  }
  .org-chart-node-label-inner {
    height: 39px !important;
    padding: 0 10px !important;
  }
  .org-chart-container {
    width: max-content;
  }
  .treedialog .el-dialog {
    width: 40rem;
    .dialogcontent {
      display: flex;
      flex-direction: row;
      padding: 0.5rem;
      height: 22rem;
      overflow: hidden;
      .left {
        width: 8rem;
        flex-shrink: 0;
        border: #3570ff solid 1px;
        padding: 0.5rem;
        margin-right: 1rem;
        height: 100%;
        overflow-y: auto;
        li {
          height: 1.8rem;
          color: #fff;
          padding: 0 0.5rem;
          line-height: 1.8rem;
          cursor: pointer;
          margin-bottom: 0.2rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        li.active {
          color: #24ffb1;
          background: rgba(24, 255, 106, 0.1);
          border: #24ffb1 dashed 1px;
        }
        li:hover {
          color: #24ffb1;
        }
      }
      .right {
        flex: 1;
        width: 100%;
        overflow: hidden;
        display: flex;
        flex-direction: row;
        .img {
          width: 5rem;
          flex-shrink: 0;
          margin-right: 1rem;
          height: 6rem;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .form {
          flex: 1;
          height: 100%;
          width: 100%;
          overflow-y: auto;
          .item {
            border-bottom: #555e86 dashed 1px;
            padding: 0.4rem 0.5rem;
            display: flex;
            flex-direction: row;
            label {
              width: 4rem;
              flex-shrink: 0;
              text-align: right;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              margin-right: 10px;
            }
            span {
              color: #fff;
            }
          }
          .item:last-child {
            border-bottom: none;
          }
        }
      }
    }
  }
}
</style>